export default {"src":"/_next/static/media/icon-metamask.19401713.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};